import {
  Outlet,
  createRootRouteWithContext,
  redirect,
} from "@tanstack/react-router";
import { AuthContext } from "src/components/AuthProvider";
import { getAuth, getRedirectResult } from "firebase/auth";
import LoadingOverlay from "@/components/LoadingOverlay";
import ErrorState from "@/components/ErrorState";

export interface AppContext {
  auth: AuthContext;
}

export const Route = createRootRouteWithContext<AppContext>()({
  component: Root,
  staticData: {
    title: "Trader Sage",
  },
  beforeLoad: async () => {
    await getAuth().authStateReady();

    if (await getRedirectResult(getAuth())) {
      throw redirect({ to: "/" });
    }
  },
  pendingComponent: () => <LoadingOverlay isLoading={true} />,
  errorComponent: ({ error }) => <ErrorState error={error} />,
  notFoundComponent: () => <ErrorState error={new Error("Not Found")} />,
});

function Root() {
  return <Outlet />;
}
